import React from "react";
import "../../resources/css/application.css";
import * as PropTypes from "prop-types";
import iconError from "../../resources/images/icon-error-2.svg";


const ErrorAlert = (props) => {

  const {message} = props;

  return (
    <div>
      <div className="alert-error mb-5">
        <img alt={""} className="alert-error__icon" src={iconError}/>
        <p className="alert-error__msg">{message}</p>
      </div>
    </div>
  );
};

ErrorAlert.propTypes = {
  message: PropTypes.string
};

export default ErrorAlert;
